<template>
  <div class="rg-device">
    <single-mod :mod="curMod" :valueOp="valueOp" :rightEchart="lineOp" :up-fn="v => updateData(v)">
      <template v-slot="wsData">
        <div
          class="device-info"
          v-if="
            wsData.singleDeviceDetail &&
            wsData.singleDeviceDetail.mods &&
            wsData.singleDeviceDetail.mods[curMod]
          "
        >
          <el-row>
            <el-col :span="12">
              <span>设备状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.state | stateClass(true)">
                {{ wsData.singleDeviceDetail.state | stateText }}
              </span>
            </el-col>
            <el-col :span="12">
              <span>运行状态:</span>
              <span class="state" :class="wsData.singleDeviceDetail.runstate | runstateClass(true)">
                {{ wsData.singleDeviceDetail.runstate | runstateText }}
              </span>
            </el-col>
          </el-row>
          <el-row>
            <div
              style="
                width: 50%;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                font-size: 26px;
              "
            >
              <ModsIcon icon="icon-he" :wsData="wsData.singleDeviceDetail" :mods="curMod" />
            </div>
          </el-row>
          <el-row>
            <div style="margin-bottom: 10px">设备名称: {{ wsData.singleDeviceDetail.name }}</div>
            <div>设备编号: {{ wsData.singleDeviceDetail.sn }}</div>
          </el-row>
        </div>
      </template>
    </single-mod>
  </div>
</template>

<script>
import SingleMod from '../components/single-mod';
import ModsIcon from '@/components/mods-icon';
import { graColor } from '@/views/realdata/FCBR-100/options';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';

export default {
  name: 'RG500',
  components: {
    SingleMod,
    ModsIcon
  },
  data() {
    return {
      curMod: 'nuclearMod',
      valueOp: [
        {
          title: 'γ实时数(CPS)',
          key: 'radDose'
        },
        {
          title: 'γ本底数(CPS)',
          key: 'radDoseBground'
        }
      ],
      lineOp: [
        lineAreaStyle({
          title: { text: 'γ数(CPS)' },
          color: ['#21d4bc', '#630da8'],
          legend: {
            data: ['本底', '伽马数'],
            icon: 'circle',
            textStyle: {
              color: '#fff'
            }
          },
          visualMap: {
            top: 0,
            right: 10,
            orient: 'horizontal',
            textGap: 5,
            itemWidth: 14,
            itemHeight: 10,
            pieces: [
              { gt: 0, lte: 1, color: '#03b36e' },
              { gt: 1, color: '#FF4847' }
            ],
            textStyle: {
              color: '#00eeff',
              fontSize: 10
            }
          },
          series: [
            {
              name: '本底',
              areaStyle: { color: graColor('rgba(38, 231, 202, 0.5)', 'rgba(38, 231, 202, 0.1)') }
            },
            {
              type: 'line',
              symbolSize: 10,
              smooth: true,
              name: '伽马数',
              data: [],
              areaStyle: { color: graColor('rgba(62, 11, 116, 0.5)', 'rgba(62, 11, 116, 0.1)') },
              markLine: {
                data: [
                  {
                    name: '阈值',
                    yAxis: '',
                    lineStyle: {
                      color: '#FF4847'
                    }
                  }
                ]
              }
            }
          ]
        })
      ]
    };
  },
  methods: {
    updateData(newVal) {
      const { beginTime } = newVal;
      const { radDoseThreshold, radDoseBground, radDose } = newVal.mods[this.curMod];
      this.wsData = newVal;
      this.radDose = radDose;
      this.lineOp[0].series[0].data.push([beginTime, radDoseBground]);
      this.lineOp[0].series[1].data.push([beginTime, radDose]);
      this.lineOp[0].series[1].markLine.data[0].yAxis = radDoseThreshold;
      this.lineOp[0].visualMap.pieces[0].lte = radDoseThreshold;
      this.lineOp[0].visualMap.pieces[1].gt = radDoseThreshold;
      if (this.lineOp[0].series[0].data.length > 20) {
        this.lineOp[0].series[0].data.shift();
        this.lineOp[0].series[1].data.shift();
      }
    }
  }
};
</script>

<style lang="scss">
.rg-device {
  height: 100%;
  .device-info {
    height: 100%;
    color: #00a0e9;
    font-size: 26px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .state {
      @include state-textstyle;
    }
  }
  .el-row {
    text-align: center;
  }
}
</style>
